export default __webpack_public_path__ + "static/media/DEFI5-QUICK.9df0d1fe.png";